import * as React from "react";
import { Box, Typography, Stack, Toolbar } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import StartingPageContent from "../components/StartingPage/StartingPageContent";
import {
  getFormSubmissionById,
  setCheckedFormById,
  setFormSubmissionChangeAnswer,
} from "../store/formInputesSubmission";
import { uploadFile, clearUpdateFileId } from "../store/uploadFile";
import {
  submitFormSubmission,
  submitFormSubmissionOverride,
} from "../store/formSubmission";
import { useDispatch, useSelector } from "react-redux";
import ContainerDashboard from "../components/UI/ContainerDashboard";
import BottomToolbar from "../components/UI/BottomToolbar";
import DialogDelete from "../components/UI/DialogDelete";
import LogTable from "../components/FormatePlotesuara/LogTable";
import DialogComment from "../components/UI/DialogComment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonToolbar from "../components/UI/FormGridInputetComponents/ButtonToolbar";
import { DataGrid, GridToolbarExport } from "@mui/x-data-grid";
import ButtonImport from "../components/UI/ButtonImport";
import InputetTableImportExcel from "../components/FormGridInputetTable/InputetTableImportExcel";
import ButtonAdd from "../components/UI/ButtonAdd";
import EditorInputs from "../components/FormGridInputetTable/EditorInputs";
import BoxRowButtonsIcon from "../components/UI/BoxRowButtonsIcon";
import RowButtonIcon from "../components/UI/RowButtonIcon";
import useFormInputesSubmissionStore from "../store/zustandStore/formInputesSubmissionZs";
import gridLabels from "../components/Labels/GridLabels";
import SearchInput from "../components/UI/SearchInput";
import debounce from "../utils/debounce";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { ButtonExportCustom } from "../components/UI/ButtonExport";
import { getMaxOrder } from "../utils/maxOrderLine";

const FormGridInputetTable = () => {
  const initialAnswers = [];

  const user = useSelector((state) => state.auth.user);
  const {
    fetchForminputesSubmissionsZs,
    formInputesSubmissionZs,
    getFormSubmissionZs,
    formSubmissionZs,
    linesZs,
    submitInputeLinesZs,
    deleteFormInputLineZs,
    searchTextLinesZs,
    currentPageLinesZs,
    pageSizeLinesZs,
    setSearchTextLinesZs,
    setPageLinesZs,
    totalPagesLinesZs,
    filterLinesZs,
    setFilterLinesZs,
    total,
  } = useFormInputesSubmissionStore();

  const isAdministrator = user?.role === "ROLE_EXECUTIVE" ? true : false;
  const isGlobalEditor = user?.isGlobalEditor ? user?.isGlobalEditor : false;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const stateFormInputId = location.state.stateFormInputId;
  const stateForm = location.state.stateForm;
  const nameForm = location.state.nameForm;

  const analystCheck = location.state?.analystCheck;
  const status = location.state?.status;
  const company = location.state?.company;

  const editAccess =
    ["ROLE_OSHMA", "ROLE_INPUTER"].includes(user?.role) && stateForm !== "old";

  const tableLogAccess =
    ["ROLE_EXECUTIVE", "ROLE_SOFT_EXECUTIVE", "ROLE_ANALYST"].includes(
      user?.role,
    ) && stateForm === "old";

  const formSubmissionState = location.state?.formSubmissionState;
  const variableSubmission = location.state?.variableSubmission;

  const { formInputesSubmission, commentSubmission } = useSelector(
    (state) => state.formInputesSubmission,
  );

  // Convert columnsData into GridColDef format
  const columnsTable = formInputesSubmission?.map(({ id, label }) => ({
    field: id,
    headerName: label,
    minWidth: 150,
    flex: 1,
  }));

  const { uplaodFileId } = useSelector((state) => state.uplaodFile);

  const [errorValues, setErrorValues] = React.useState([]);
  const [stateComment, setStateComment] = React.useState("");
  const [stateFileId, setStateFileId] = React.useState("");
  const [stateCommentSend, setStateCommentSend] = React.useState("");
  const [dataSendWithComment, setDataSendWithComment] = React.useState({});
  const [dataSendWithApprove, setDataSendWithApprove] = React.useState({});
  const [errorDataCommnet, setErrorDataComment] = React.useState(false);
  const [stateDialogWarning, setStateDialogWarning] = React.useState(false);
  const [stateDialogComment, setStateDialogComment] = React.useState(false);
  const [stateDialogApprove, setStateDialogApprove] = React.useState(false);
  const [stateDialogDelete, setStateDialogDelete] = React.useState(false);
  const [inputsEdit, setInputsEdit] = React.useState({});

  const [newRow, setNewRow] = React.useState(false);
  const [openRowEditor, setOpenRowEditor] = React.useState(false);

  const [files, setFiles] = React.useState([]);
  const [checked, setChecked] = React.useState(false);
  const [stateDialogExtraSubmission, setStateDialogExtraSubmission] =
    React.useState(false);
  const [finalDataSend, setFinalDataSend] = React.useState(false);
  const [isOpenImport, setIsOpenImport] = React.useState(false);

  const changeHandlerFiles = (event) => {
    const f = event.target.files[0];
    const formData = new FormData();
    formData.append("file", f);
    dispatch(uploadFile({ fileData: formData }));
    setFiles(event.target.files[0]);
  }; // Upload file

  const onDeleteFile = () => {
    setFiles([]);
    dispatch(clearUpdateFileId());
  };

  const [logsFormInputesSubmission, setLogsFormInputesSubmission] =
    React.useState([]);

  React.useEffect(() => {
    fetchForminputesSubmissionsZs();
    if (stateFormInputId) {
      // dispatch(getFormSubmissionById({ id: stateFormInputId }));
      getFormSubmissionZs(stateFormInputId);

      // setChecked(analystCheck);
    }
  }, [stateFormInputId, stateForm, nameForm]);

  React.useEffect(() => {
    if (stateFormInputId) {
      dispatch(getFormSubmissionById({ id: stateFormInputId }));
    }
    if (isAdministrator) {
      dispatch(getFormSubmissionById({ id: stateFormInputId }));
      setLogsFormInputesSubmission(formInputesSubmission);
    }
  }, []);

  React.useEffect(() => {
    if (isAdministrator) {
      setLogsFormInputesSubmission(formInputesSubmission);
    }
  }, [formInputesSubmission]);

  const saveForm = () => {
    formInputesSubmission.map((item) => {
      if (item.answer != null) {
        initialAnswers.push({
          answer: item.answer ? item.answer.answer : null,
          id: item.answer ? item.answer.id : null,
        });
      } else {
      }
    });
    const dataSend = {};
    dataSend.id = stateFormInputId;
    dataSend.answers = initialAnswers;
    if (user?.role === "ROLE_EDITOR") {
      dataSend.status = "REVIEWED";
    } else {
      if (stateForm === "new") {
        dataSend.status = "DRAFT";
      } else {
        dataSend.status = "ACTIVE";
      }
    }
    dataSend.extraSubmission = false;
    dispatch(submitFormSubmission({ formSubmission: dataSend }));
    onBackNavigation();
  }; // Save form

  const sendForm = (e) => {
    var initialAnswersError = [];
    // formInputesSubmission.map((item) => {
    //   if (item.answer.answer !== "" || item.type !== "DOC") {
    //     initialAnswers.push({
    //       answer: item.answer ? item.answer.answer : null,
    //       id: item.answer ? item.answer.id : null,
    //     });
    //   } else {
    //     if (item.type !== "DOC") {
    //       initialAnswersError.push(item);
    //     }
    //   }
    // });
    setErrorValues(initialAnswersError);

    // if (initialAnswersError.length === 0) {
    const dataSend = {};
    dataSend.id = stateFormInputId;
    dataSend.answers = initialAnswers;

    if (isGlobalEditor && stateForm === "old") {
      dataSend.status = "REVIEWED";
      if (uplaodFileId !== "") {
        dataSend.file = uplaodFileId;
      }
      setDataSendWithComment(dataSend);
      handleCommentEdit(dataSend);
    } else {
      if (user?.role === "ROLE_EDITOR") {
        ///message: A jeni i sigurt qe doni te Aprovoni Formen?
        dataSend.status = "REVIEWED";
        dataSend.extraSubmission = false;
        setDataSendWithApprove(dataSend);
        handleApprove(dataSend);
      } else {
        dataSend.status = "SUBMITTED";
        if (variableSubmission) {
          setStateDialogExtraSubmission(true);
          setFinalDataSend(dataSend);
        } else {
          const finalDataSendTemp = {
            ...dataSend,
            extraSubmission: false,
          };
          dispatch(submitFormSubmission({ formSubmission: finalDataSendTemp }));
          navigate(-1);
        }
      }
    }
  }; // Send final form

  const rejecteForm = (e) => {
    formInputesSubmission.map((item) => {
      // if (item.answer != null) {
      initialAnswers.push({
        answer: item.answer ? item.answer.answer : null,
        id: item.answer ? item.answer.id : null,
      });
      // } else {
      // }
    });
    const dataSend = {};
    dataSend.id = stateFormInputId;
    dataSend.answers = initialAnswers;
    dataSend.status = "DRAFT";
    setDataSendWithComment(dataSend);
    handleCommentEdit(dataSend);

    // dispatch(submitFormSubmission({ formSubmission: dataSend }));
    // onBackNavigation();
  };

  const handleSendDataSimple = () => {
    const finalDataSendTemp = { ...finalDataSend, extraSubmission: false };
    dispatch(submitFormSubmission({ formSubmission: finalDataSendTemp }));
    navigate(-1);
  };

  const handleSendDataExtra = () => {
    const finalDataSendTemp = { ...finalDataSend, extraSubmission: true };
    dispatch(submitFormSubmission({ formSubmission: finalDataSendTemp }));
    navigate(-1);
  };

  const handleWarningMessage = (e) => {
    setStateDialogWarning(true);
  };

  const handleBackForm = (e) => {
    setStateDialogWarning(false);
  };

  const handleApprove = (e) => {
    setStateDialogApprove(true);
  };

  const handleBackFormApprove = (e) => {
    setStateDialogApprove(false);
  };

  const handleCommentEdit = (e) => {
    setErrorDataComment(false);
    setStateDialogComment(true);
  };

  const handleBackFormComment = (e) => {
    setStateDialogComment(false);
  };

  // rejected Form
  const handleSendDataComent = () => {
    const tempDataWithComent = dataSendWithComment;

    if (stateCommentSend == "" || stateCommentSend.trim().length === 0) {
      setErrorDataComment(true);
    } else {
      tempDataWithComent.comment = stateCommentSend;
      if (uplaodFileId !== "") {
        tempDataWithComent.file = uplaodFileId;
      }
      dispatch(submitFormSubmission({ formSubmission: tempDataWithComent }));
      navigate(-1);
    }
  };

  const handleSendDataApprove = () => {
    dispatch(submitFormSubmission({ formSubmission: dataSendWithApprove }));
    navigate(-1);
  };

  const changeComment = (e) => {
    const commentValue = e.target.value;
    if (commentValue !== "" || commentValue === " ") {
      setErrorDataComment(false);
      setStateCommentSend(e.target.value);
    } else {
    }
  };

  const handleChangeCheck = (event) => {
    dispatch(setCheckedFormById({ id: stateFormInputId }));
    setChecked(event.target.checked);
  };

  const onBackNavigation = () => {
    navigate(-1);
  };

  const companyName = company?.name ? " - " + company?.name : "";

  const addNew = () => {
    setNewRow(true);
    setOpenRowEditor(true);
  };

  const currentlySelected = (e) => {
    setNewRow(false);
    setInputsEdit(e.row);
    setOpenRowEditor(true);
  };

  const handleClickDelete = (e) => {
    setInputsEdit(e.row);
    setStateDialogDelete(true);
  };

  const handleDeleteRowInputs = (e) => {
    const tempDataDelete = { formId: stateFormInputId, lineId: inputsEdit.id };
    deleteFormInputLineZs(tempDataDelete);
    setStateDialogDelete(false);
  };

  const handleCloseDialogDelete = (e) => {
    setStateDialogDelete(false);
  };

  const handleSubmitLines = async (data) => {
    if (!newRow) {
      await deleteFormInputLineZs({ formId: stateFormInputId, lineId: inputsEdit.id }, true);
      await submitInputeLinesZs(data, "Rekordi u ndryshua me sukses!");
    } else {
      await submitInputeLinesZs(data);
    }
    setOpenRowEditor(false);
  };

  const handleSubmitImportLines = async (data) => {
    await submitInputeLinesZs(data);
  };

  // 🔁 Memoized debounced handler
  const debouncedSearch = React.useMemo(() => {
    return debounce((value) => {
      setSearchTextLinesZs(value);
      setFilterLinesZs();
    }, 300); // 300ms delay
  }, [setSearchTextLinesZs]);

  const handleSearchChange = (e) => {
    debouncedSearch(e.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPageLinesZs(event);
  };

  const handleSelectLog = (e) => {
    const getLog = e.answers;
    setStateComment(e?.comment);
  };

  function CustomToolbar({ ...other }) {
    return (
      <GridToolbarContainer {...other}>
        <GridToolbarExport
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fileName:
              "Data_" +
              nameForm.charAt(0).toUpperCase() +
              nameForm.slice(1) +
              companyName +
              ".csv",
          }}
        ></GridToolbarExport>
        {/* <ButtonExportCustom
          href={`data:text/csv;charset=utf-8,${escape(filterLinesZs)}`}
          download={
            "Data_" +
            nameForm.charAt(0).toUpperCase() +
            nameForm.slice(1) +
            companyName +
            ".csv"
          }
        ></ButtonExportCustom> */}
      </GridToolbarContainer>
    );
  }

  return (
    <StartingPageContent
      pageName={
        stateForm === "old"
          ? isAdministrator
            ? "Logs - Forma e plotësuar"
            : "Forma e plotësuar"
          : "Plotësimi i formës"
      }
      back
      onClick={onBackNavigation}
    >
      <Stack spacing={2}>
        <Box sx={{ flexGrow: 1 }}>
          <ContainerDashboard
            header={
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5" sx={{ ml: 1, lineHeight: "2" }}>
                  {nameForm.charAt(0).toUpperCase() +
                    nameForm.slice(1) +
                    companyName}
                </Typography>

                <>
                  <SearchInput onChange={handleSearchChange} />

                  <Stack
                    display="flex"
                    direction="row"
                    gap="8px"
                    alignItems="center"
                  >
                    {editAccess && (
                      <>
                        <ButtonAdd onClick={addNew} />
                        <ButtonImport onClick={() => setIsOpenImport(true)} />
                      </>
                    )}
                  </Stack>
                </>
              </Box>
            }
            analystCheck={checked}
            onChange={handleChangeCheck}
            status={status}
            id={stateFormInputId}
          >
            {tableLogAccess && (
              <Box>
                <Box
                  sx={{
                    width: "100%",
                    mb: 2,
                  }}
                >
                  <LogTable
                    id={stateFormInputId}
                    title={
                      nameForm?.charAt(0)?.toUpperCase() + nameForm?.slice(1)
                    }
                    onSelectLog={handleSelectLog}
                  ></LogTable>
                </Box>
              </Box>
            )}
            {tableLogAccess && stateComment !== "" && stateComment !== null && (
              <div>
                Komenti i Ndryshimit:{" "}
                <span style={{ fontSize: "16px", color: "#ff5858" }}>
                  {stateComment}
                </span>
              </div>
            )}
            {commentSubmission !== "" && commentSubmission !== null && (
              <div>
                Komenti i Editorit:{" "}
                <span style={{ fontSize: "16px", color: "#ff5858" }}>
                  {commentSubmission}
                </span>
              </div>
            )}
            <DataGrid
              localeText={gridLabels}
              onRowDoubleClick={currentlySelected}
              columns={
                formInputesSubmission
                  ? [
                      ...columnsTable,
                      editAccess && {
                        headerName: "",
                        overflow: "hidden",
                        field: "editim",
                        editable: false,
                        minWidth: 150,
                        // width: 100,
                        flex: 1,
                        justifyContent: "flex-end",
                        disableClickEventBubbling: true,
                        align: "right",
                        background: "red",
                        headers: false,
                        renderHeader: () => {},
                        renderCell: (params) => (
                          <BoxRowButtonsIcon sx={{ minWidth: "100px" }}>
                            <RowButtonIcon
                              onClick={(event) => {
                                currentlySelected(params);
                              }}
                            >
                              <EditIcon />
                            </RowButtonIcon>
                            <RowButtonIcon
                              delete
                              onClick={(event) => {
                                handleClickDelete(params);
                              }}
                            >
                              <DeleteIcon />
                            </RowButtonIcon>
                          </BoxRowButtonsIcon>
                        ),
                      },
                    ]
                  : []
              }
              rows={filterLinesZs ? filterLinesZs : []}
              // pagination={false}
              page={currentPageLinesZs}
              onPageChange={handleChangePage}
              count={totalPagesLinesZs}
              rowCount={total}
              pageSize={pageSizeLinesZs}
              pagination
              paginationMode="server"
              disableVirtualization
              components={{
                Toolbar: CustomToolbar,
                customExports: [
                  {
                    translationKey: "exportAsICal",
                    // some function that returns the content of the file
                    createContent: (visibleColumns, visibleSortedRows) => {
                      // TODO
                      return "";
                    },
                    filename: "games-schedule.ical",
                    type: "text/calendar",
                  },
                ],
              }}
              // experimentalFeatures={{ newEditingApi: true }}
            ></DataGrid>
          </ContainerDashboard>
        </Box>
      </Stack>
      <Toolbar></Toolbar>
      {stateForm === "old" ? null : (
        <BottomToolbar>
          {user?.role === "ROLE_EDITOR" && (
            <ButtonToolbar variantStatus="rejected" onClick={rejecteForm} />
          )}
          <ButtonToolbar
            variantStatus={user?.role === "ROLE_EDITOR" ? "approve" : "save"}
            onClick={user?.role === "ROLE_EDITOR" ? sendForm : saveForm}
          />
          {user?.role !== "ROLE_EDITOR" ? (
            <ButtonToolbar variantStatus="send" onClick={sendForm} />
          ) : null}
        </BottomToolbar>
      )}
      {isGlobalEditor && stateForm === "old" ? (
        <BottomToolbar>
          <ButtonToolbar variantStatus="approve" onClick={sendForm} />
        </BottomToolbar>
      ) : null}
      <DialogDelete
        open={stateDialogWarning}
        agreedelete={handleBackForm}
        warning
        description={
          "Keni vlera të pa plotësuara, ju lutem plotësoni të gjitha fushat e kërkuara!"
        }
      />
      <DialogDelete
        open={stateDialogExtraSubmission}
        description={"A doni të rikrijoni një form tjetër?"}
        disagreedelete={handleSendDataSimple}
        agreedelete={handleSendDataExtra}
      />
      <DialogComment
        open={stateDialogComment}
        //comment={commen}
        required
        error={errorDataCommnet ? errorDataCommnet : undefined}
        //error={errorDataCommnet?error={condition ? value : undefined}}
        inputref={stateComment}
        onchangecomment={changeComment}
        disagreeComment={handleBackFormComment}
        submitComment={handleSendDataComent}
        description={"Lini komentin tuaj për ndryshimet përkatëse"}
        // files={files}
        filename={files?.name}
        filevalue={files}
        onDelete={onDeleteFile}
        onchangefile={changeHandlerFiles}
      />
      <DialogDelete
        open={stateDialogApprove}
        description={"Jeni të sigurt që doni të Aprovoni këtë formë?"}
        disagreedelete={handleBackFormApprove}
        agreedelete={handleSendDataApprove}
      />
      <InputetTableImportExcel
        isOpen={isOpenImport}
        formId={stateFormInputId}
        formData={formInputesSubmission}
        onClose={() => setIsOpenImport(false)}
        name={
          nameForm.charAt(0).toUpperCase() + nameForm.slice(1) + companyName
        }
        maxOrder={getMaxOrder(linesZs ? linesZs : [])}
        onSubmitData={handleSubmitImportLines}
      />
      <EditorInputs
        open={openRowEditor}
        isstatusnew={newRow}
        formId={stateFormInputId}
        order={newRow ? getMaxOrder(linesZs ? linesZs : []) : inputsEdit?.order}
        formData={formInputesSubmission}
        onClose={() => setOpenRowEditor(false)}
        inputsEdit={inputsEdit}
        name={
          nameForm.charAt(0).toUpperCase() + nameForm.slice(1) + companyName
        }
        editAccess={editAccess}
        onSubmitData={handleSubmitLines}
      />
      <DialogDelete
        open={stateDialogDelete}
        disagreedelete={handleCloseDialogDelete}
        agreedelete={handleDeleteRowInputs}
        description=" Jeni të sigurt që doni ta fshini këtë rekord?"
      />
    </StartingPageContent>
  );
};

export default FormGridInputetTable;
